import React, { FunctionComponent, useState } from "react"
import { Button, Icon } from "@kuali/pure-ui"
import "../html-editor/styles.scss"

import { postHTML } from "../html-editor/update-editor-request"

interface Props {
  inputValue: string
  defaultValue: string
  inputName: string
}

// The single input submit component allows user  user to submit a value to an endpoint or restore
// default text provided
const SingleInputSubmit: FunctionComponent<Props> = ({
  inputValue,
  defaultValue,
  inputName
}) => {
  const [value, setValue] = useState(inputValue)
  const [isLoadingUpdateResponse, setIsLoadingUpdateResponse] = useState(true)
  const [isUpdated, setIsUpdated] = useState(false)

  const postEditor = async (data: string) => {
    setIsLoadingUpdateResponse(true)
    const result = await postHTML(data, inputName)

    if (result) {
      setIsLoadingUpdateResponse(false)
      if (result.isSuccess) {
        setIsUpdated(true)
      } else {
        setIsUpdated(false)
      }
    }
  }

  return (
    <div className="editor-footer">
      <label htmlFor={inputName}>Custom Text</label>
      <input
        id={inputName}
        type="text"
        value={value}
        onChange={(event) => {
          setIsLoadingUpdateResponse(true)
          setValue(event.target.value)
        }}
        name={inputName}
      />
      <Button
        size="large"
        kind="transparent"
        shadow={true}
        block={false}
        onClick={(event) => {
          event.preventDefault()
          setValue(defaultValue)
        }}
      >
        Restore Default Text
      </Button>
      <Button
        size="large"
        kind="solid"
        shadow={true}
        block={false}
        onClick={(event) => {
          event.preventDefault()
          postEditor(value)
        }}
      >
        Update
      </Button>
      {!isLoadingUpdateResponse && isUpdated && (
        <div className="editor-status">
          <p role="region" aria-live="polite">
            <Icon name="check" /> Your content has been successfully updated
          </p>
        </div>
      )}
      {!isLoadingUpdateResponse && !isUpdated && (
        <div className="editor-status">
          <p role="region" aria-live="polite">
            <Icon name="alert-warning" /> Your content could not be updated. Please
            try again later or contact support.
          </p>
        </div>
      )}
    </div>
  )
}

export default SingleInputSubmit
